<template>
	<PopupRouterView :showLeftIcon="true" label="Part Input" okTitle="Save" cancelTitle="Cancel" entityName="part"
		:documentId="mainRecordId" @saveMethod="saveAction" @hideMethod="onHidden" ref="partInput">


		<b-card header="Part" class="mb-3 card-max-width">
			<b-row>
				<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-part-number" label-cols-lg="12" label="Part Number"
						label-for="input-part-number" size="sm" :model.sync="model.partNumber" :isRequired="true"
						:state="validateState('partNumber')"
						:errorMessage="getErrorMessage(errorMessage.partNumber, 'partNumber')" @change="updateData" />
					<app-input-textbox id="fieldset-part-name" label-cols-lg="12" label="Part Name"
						label-for="input-part-name" size="sm" :model.sync="model.partName" :isRequired="true"
						:state="validateState('partName')"
						:errorMessage="getErrorMessage(errorMessage.partName, 'partName')" @change="updateData" />
					<app-input-textarea id="fieldset-part-specification" label-cols-lg="12" label="Part Specification"
						label-for="input-part-specification" size="sm" :model.sync="model.partSpecification"
						@change="updateData" />
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id"
						label-cols-lg="12" label="Part Reference" id="fieldset-part-reference" size="sm"
						:model.sync="model.partReferenceId"
						:selected="model.partReference != null ? model.partReference.partNumber : ''" @input="getParts"
						@change="updateData" :isSelectMethodExists="true" @onSelectMethod="setSelectedPartReference" />
					<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id"
						label-cols-lg="12" label="Customer" id="fieldset-customer" size="sm" :model.sync="model.customerId"
						:isRequired="true" :state="validateState('customerId')"
						:errorMessage="getErrorMessage(errorMessage.customerId, 'customerId')"
						:selected="model.customer != null ? model.customer.code : ''" @input="getCustomers"
						@change="updateData" :isSelectMethodExists="true" @onSelectMethod="setSelectedCustomer" />
					<!-- <app-input-textbox id="fieldset-stock-level-customer" label-cols-lg="12"
						label="Stock Level Customer (Day)" label-for="input-stock-level-customer" size="sm"
						:isRequired="true" :model.sync="model.stockLevelCustomer" @change="updateData" /> -->
				</b-col>
				<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="partClassifications" optionsLabel="code" optionsKey="id"
						label-cols-lg="12" label="Part Classification" id="fieldset-part-classification" size="sm"
						:model.sync="model.partClassificationId"
						:selected="model.partClassification != null ? model.partClassification.code : ''"
						@input="getPartClassifications" @change="updateData" :isSelectMethodExists="true"
						@onSelectMethod="setSelectedPartClassification" :isRequired="true"
						:state="validateState('partClassificationId')"
						:errorMessage="getErrorMessage(errorMessage.partClassificationId, 'partClassificationId')" />
					<app-input-combobox-autocomplete :options="packagingTypes" optionsLabel="code" optionsKey="id"
						label-cols-lg="12" label="Packaging Type" id="fieldset-packaging-type" size="sm"
						:model.sync="model.packagingTypeId"
						:selected="model.packagingType != null ? model.packagingType.code : ''" @input="getPackagingTypes"
						@change="updateData" :isSelectMethodExists="true" @onSelectMethod="setSelectedPackagingType"
						:isRequired="true" :state="validateState('packagingTypeId')"
						:errorMessage="getErrorMessage(errorMessage.packagingTypeId, 'packagingTypeId')" />
					<app-input-combobox-autocomplete :options="uoms" optionsLabel="code" optionsKey="id" label-cols-lg="12"
						label="Uom" id="fieldset-uom" size="sm" :model.sync="model.uomId"
						:selected="model.uom != null ? model.uom.code : ''" @input="getUoms" @change="updateData"
						:isSelectMethodExists="true" @onSelectMethod="setSelectedUom" :isRequired="true"
						:state="validateState('uomId')" :errorMessage="getErrorMessage(errorMessage.uomId, 'uomId')" />
					<app-input-combobox-autocomplete :options="uoms" optionsLabel="code" optionsKey="id" label-cols-lg="12"
						label="Uom PO" id="fieldset-uom-po" size="sm" :model.sync="model.uomPoId"
						:selected="model.uomPo != null ? model.uomPo.code : ''" @input="getUoms" @change="updateData"
						:isSelectMethodExists="true" @onSelectMethod="setSelectedUomPo" :isRequired="true"
						:state="validateState('uomPoId')" :errorMessage="getErrorMessage(errorMessage.uomPoId, 'uomId')" />
					
						<!-- <app-input-combobox-autocomplete :options="uoms" optionsLabel="code" optionsKey="id" label-cols-lg="12"
						label="Uom Po" id="fieldset-uom-po" size="sm" :model.sync="model.uomPoId"
						:selected="model.uomPo != null ? model.uomPo.code : ''" @input="getUoms" @change="updateData"
						:isSelectMethodExists="true" @onSelectMethod="setSelectedUomPo" :isRequired="true"
						:state="validateState('uomPoId')" :errorMessage="getErrorMessage(errorMessage.uomPoId, 'uomPoId')" /> -->
					<app-input-textbox id="fieldset-standar-packaging-qty" label-cols-lg="12" label="Standard Packaging Qty"
						label-for="input-standar-packaging-qty" size="sm" :model.sync="model.standarPackagingQty"
						@change="updateData" :isRequired="true" :state="validateState('standarPackagingQty')"
						:errorMessage="getErrorMessage(errorMessage.standarPackagingQty, 'standarPackagingQty')" />
					<!-- <app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id"
						label-cols-lg="12" label="Vendor Subcontract" id="fieldset-vendor-subcontract" size="sm"
						:model.sync="model.vendorSubcontractId"
						:selected="model.vendorSubcontract != null ? model.vendorSubcontract.code : ''" @input="getVendors"
						@change="updateData" :isSelectMethodExists="true" @onSelectMethod="setSelectedVendorSubcontract"
						:isEditable="checkSubContract" /> -->
					<b-row>
						<b-col cols="12" lg="6">
							<app-input-checkbox id="fieldset-is-is-direct-delivery" label-cols-lg="12"
								label="Direct Delivery ?" label-for="input-is-is-direct-delivery" size="sm"
								:model.sync="model.isDirectDelivery" checkedValue="Yes" uncheckedValue="No"
								@change="updateData" />
						</b-col>
						<b-col cols="12" lg="6">
							<app-input-checkbox id="fieldset-is-is-need-repacking" label-cols-lg="12"
								label="Need Repacking ?" label-for="input-is-is-need-repacking" size="sm"
								:model.sync="model.isNeedRepacking" checkedValue="Yes" uncheckedValue="No"
								@change="updateData" />
						</b-col>
					</b-row>
				</b-col>

			</b-row>
		</b-card>

		<app-table-input title="List Supplier / SubCont" :bordered="true" :items="partDetails" :fields="fieldsPartDetail"
			:busy="isDataLoading" :sort-by.sync="sortByPartDetail" :sort-desc.sync="sortDescPartDetail" small responsive
			@editButtonMethod="editRowDataPartDetail" @deleteButtonMethod="deleteRowDataPartDetail"
			@showPopupAddMethod="addDataPartDetail()" @showPopupUploadMethod="showPopupUploadPartDetail()"
			@downloadMethod="downloadPartDetail()" @addFromClipboardMethod="addFromClipboardPartDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardPartDetail()" :showActionButton="true" :showDeleteButton="true"
			:showAddButton="true" :showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false" :showUploadButton="false" :showDownloadButton="false"
			:isDownloadBusy="isDownloadPartDetail">

			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowPartDetailFilter = !isShowPartDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->

			<template #top-row v-if="isShowPartDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Supplier Code">
					<v-select id="input-part-detail-supplier-code-table" append-to-body label="code" :options="vendors"
						:value="filterPartDetail.supplierCodeId" :reduce="item => item.id"
						v-model="filterPartDetail.supplierCodeId" @search="getVendors" :filterable="true"></v-select>
				</b-th>

				<b-th></b-th>
			</template>

			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + (partDetailPageSize * (currentPartDetailPage - 1))) }}
			</template>

			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>

			<template v-slot:cell(supplierCode)="row">
				<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id"
					:id="'input-part-detail-supplier-code-' + row.index" label-cols-lg="12" label="Supplier Code" size="sm"
					:model.sync="row.item.supplierCodeId" @change="saveInputPartDetail(row.item)"
					:selected="row.item.supplierCode != null ? row.item.supplierCode.code : ''" @input="getVendors"
					:loading="isVendorComboLoading" :nolabel="true" />
			</template>
			<template v-slot:cell(supplierName)="row">
				<app-label label-cols-lg="12" size="sm" label="Supplier Name"
					:model="(row.item.supplierCode != null) ? row.item.supplierCode.name : null" />
			</template>


			<template v-slot:form-add-detail>
				<PartDetailInput :model="modelPartDetail" :openPopup="isShowPopupPartDetail" @resetMethod="resetModal"
					@addButtonMethod="addRowDataPartDetail" />
			</template>
			<template v-slot:upload-detail>
				<PartDetailUpload :openPopup="isShowPopupUploadPartDetail" @resetMethod="resetModal"
					@uploadButtonMethod="uploadDataPartDetail" :parentId="modelId" />
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentPartDetailPage"
				:total-rows="totalPartDetailRow"
				:per-page="partDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>


		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import Part from '@/models/Part/Part';
import PartList from '@/models/Part/PartList';
import PartFilter from '@/filters/Part/PartFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Customer from '@/models/Customer/Customer';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import PartClassification from '@/models/PartClassification/PartClassification';
import PartClassificationFilter from '@/filters/PartClassification/PartClassificationFilter';
import PackagingType from '@/models/PackagingType/PackagingType';
import PackagingTypeFilter from '@/filters/PackagingType/PackagingTypeFilter';
import Uom from '@/models/Uom/Uom';
import UomFilter from '@/filters/Uom/UomFilter';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import VendorTypeFilter from '@/filters/VendorType/VendorTypeFilter';
import VendorType from '@/models/VendorType/VendorType';
import PartDetail from '@/models/Part/PartDetail';
import PartDetailFilter from '@/filters/Part/PartDetailFilter';
import AppLabel from '@/components/AppLabel';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PartDetailInput from '@/views/Part/PartDetailInput';
import PartDetailUpload from '@/views/Part/PartDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components: {
		AppInputTextbox,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCheckbox,
		AppLabel,
		PartDetailInput, PartDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins: [validationMixin],
	validations: {
		model: {
			partNumber: { required },
			partName: { required },
			customerId: { required },
			partClassificationId: { required },
			packagingTypeId: { required },
			uomId: { required },
			uomPoId: { required },
			standarPackagingQty: { required },
		},
	},
	data() {
		return {
			errorMessage: {
				partNumber: { required: "Part Number tidak boleh kosong." },
				partName: { required: "Part Name tidak boleh kosong." },
				customerId: { required: "Customer tidak boleh kosong." },
				partClassificationId: { required: "Part Classification tidak boleh kosong." },
				packagingTypeId: { required: "Packaging Type tidak boleh kosong." },
				uomId: { required: "Uom tidak boleh kosong." },
				uomPoId: { required: "Uom Po tidak boleh kosong." },
				standarPackagingQty: { required: "Standar Packaging Qty tidak boleh kosong." },
			},
			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			fieldsPartDetail: [
				{ "frontActions": { "class": "th-actions", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "supplierCode": { "class": "th-supplier-code first-child", "label": "Supplier Code", key: 'supplierCode', sortable: false } },
				{ "supplierName": { "class": "th-supplier-name", "label": "Supplier Name", key: 'supplierName', sortable: false } },
				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			busy: false,
			isBusy: false,
			isDataLoading: false,
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelPartDetail: {},
			isShowPopupPartDetail: false,
			isShowPopupUploadPartDetail: false,
			filterPart: null,
			currentPartPage: 1,
			partPageSize: 10,
			sortByPart: '',
			sortDescPart: '',
			filterPartDetail: null,
			currentPartDetailPage: 1,
			partDetailPageSize: 10,
			sortByPartDetail: '',
			sortDescPartDetail: '',
			sortingByPartDetail: [],
			partDetails: [],
			partDetailId: '',
			totalPartDetailRow: 0,
			isShowPartDetailFilter: false,
			isDownloadPartDetail: false,
			vendors: [],
			parts: [],
			partReferences: [],
			isPartReferenceComboLoading: false,
			customers: [],
			customers: [],
			vendorTypes : [],
			isCustomerComboLoading: false,
			partClassifications: [],
			partClassifications: [],
			isPartClassificationComboLoading: false,
			packagingTypes: [],
			packagingTypes: [],
			isPackagingTypeComboLoading: false,
			uoms: [],
			uoms: [],
			isUomComboLoading: false,
			isShowPopupConfirmation: false,
			isDataCommited: false,
			mainRecordId: '',
			isPartComboLoading: false,
			isCustomerComboLoading: false,
			isPartClassificationComboLoading: false,
			isPackagingTypeComboLoading: false,
			isUomComboLoading: false,
			isVendorComboLoading: false,
			btnCheckClassification: true,
			checkSubContract: true,
		}
	},
	methods: {
		getPart: async function (id) {
			this.isBusy = true;
			Part.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPart = true;
			this.filterPart.id = this.modelId;
			Part.downloadDataDetail(this, this.filterPart).then(result => {
				this.isDownloadPart = false;
			}).catch(error => { this.isDownloadPart = false; })
		},
		getPartDetails: async function (isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPartDetail);
			if (this.modelId == null) return;
			filter.partId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByPartDetail != null) {
				this.sortingByPartDetail[this.sortByPartDetail] = this.sortDescPartDetail;
			}
			let currentPage = (this.currentPartDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalPartDetailRow + 1;
				let page = Math.ceil(totalData / this.partDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.partDetailPageSize = 0;
			// disable paging end
			PartDetail.getList(this, filter, this.sortingByPartDetail, currentPage, this.partDetailPageSize).then(result => {
				this.currentPartDetailPage = currentPage + 1;
				this.partDetails = result.data;
				this.totalPartDetailRow = result.dataCount;
			}).catch(error => { });
		},
		getParts: async function (input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.PartNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.parts = result.data
					}
					this.isPartComboLoading = false;
				})
				.catch(error => { });
		},
		getVendors: async function (input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}

			if(this.model?.partClassification == null || this.model?.partClassification == undefined ){
				this.vendors = [];
				return;
			}

			if(this.model?.partClassification?.code?.toUpperCase() == "FG" || this.model?.partClassification?.code?.toUpperCase() == "WIP" ){
				let vendorSubCont = this.vendorTypes.find(obj => obj.name.toUpperCase() == "SUBCONTRACT");
				filter.vendorTypeId = vendorSubCont?.id;
			}

			if(this.model?.partClassification?.code?.toUpperCase() == "RM" || this.model?.partClassification?.code?.toUpperCase() == "COMPONENT" ){
				let vendorSupplier = this.vendorTypes.find(obj => obj.name.toUpperCase() == "SUPPLIER");
				filter.vendorTypeId = vendorSupplier?.id;
			}

			this.isVendorComboLoading = true;
			Vendor.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.vendors = result.data
					}
					this.isVendorComboLoading = false;
				})
				.catch(error => { });
		},
		getVendorTypes : async function(input) {
			let filter = new VendorTypeFilter();
			if (input != undefined) {
				filter.code = input;
			}
			VendorType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendorTypes = result.data
				}
			})
			.catch(error => {});
		},
		getVendorsCustom: async function (input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}


			if(this.model?.partClassification == null || this.model?.partClassification == undefined ){
				this.vendors = [];
				return;
			}

			if(this.model?.partClassification?.code?.toUpperCase() == "FG" || this.model?.partClassification?.code?.toUpperCase() == "WIP" ){
				let vendorSubCont = this.vendorTypes.find(obj => obj.name.toUpperCase() == "SUBCONTRACT");
				filter.vendorTypeId = vendorSubCont?.id;
			}

			if(this.model?.partClassification?.code?.toUpperCase() == "RM" || this.model?.partClassification?.code?.toUpperCase() == "COMPONENT" ){
				let vendorSupplier = this.vendorTypes.find(obj => obj.name.toUpperCase() == "SUPPLIER");
				filter.vendorTypeId = vendorSupplier?.id;
			}


			this.isVendorComboLoading = true;
			Vendor.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.vendors = result.data
					}
					this.isVendorComboLoading = false;
				})
				.catch(error => { });
		},
		getParts: async function (input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.parts = result.data
					}
					this.isPartComboLoading = false;
				})
				.catch(error => { });
		},
		setSelectedPartReference(item) {
			if (item == undefined || item == null) {
				this.model.partReferenceId = null;
				this.model.partReference = null;
			} else {
				this.model.partReferenceId = item.id;
				this.model.partReference = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getCustomers: async function (input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Customer.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.customers = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedCustomer(item) {
			if (item == undefined || item == null) {
				this.model.customerId = null;
				this.model.customer = null;
			} else {
				this.model.customerId = item.id;
				this.model.customer = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getPartClassifications: async function (input) {
			let filter = new PartClassificationFilter();
			if (input != undefined) {
				filter.code = input;
			}
			PartClassification.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.partClassifications = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedPartClassification: function (item) {
			if (item == undefined || item == null) {
				this.model.partClassificationId = null;
				this.model.partClassification = null;
			} else {
				this.model.partClassificationId = item.id;
				this.model.partClassification = item;
				this.checkPartClassification();
			}
			this.$forceUpdate();
			this.updateData();
		},
		checkPartClassification: function () {
			this.btnCheckClassification = true;
			this.checkSubContract = true;
			if (!this.model.partClassificationId) return;
			let item = this.model.partClassification;

			if (item.code.toUpperCase() == "RM" || item.code.toUpperCase() == "COMPONENT") {
				this.btnCheckClassification = true;
				this.checkSubContract = false;
				// if (this.model.vendorSubcontractId != null) {
				// 	this.setSelectedVendorSubcontract(null)
				// }
				this.getVendorsCustom();

			}
			if (item.code.toUpperCase() == "WIP" || item.code.toUpperCase() == "FG") {
				this.btnCheckClassification = false;
				this.checkSubContract = true;
				// if (this.partDetails == null || this.partDetails.length == 0) return;
				// this.partDetails.forEach(data => {
				// 	this.$store.dispatch("addCheckData", data.id);
				// })
				// let data = this.$store.state.dataIds;
				// if (data.length > 0) {
				// 	PartDetail.deleteMultipleData(this).then(result => {
				// 		this.getPartDetails();
				// 	}).catch(error => { });
				// }

				// console.log(this.partDetails);
				this.getVendorsCustom();
			}
		},
		getPackagingTypes: async function (input) {
			let filter = new PackagingTypeFilter();
			if (input != undefined) {
				filter.code = input;
			}
			PackagingType.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.packagingTypes = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedPackagingType(item) {
			if (item == undefined || item == null) {
				this.model.packagingTypeId = null;
				this.model.packagingType = null;
			} else {
				this.model.packagingTypeId = item.id;
				this.model.packagingType = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getUoms: async function (input) {
			let filter = new UomFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Uom.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.uoms = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedUom(item) {
			if (item == undefined || item == null) {
				this.model.uomId = null;
				this.model.uom = null;
			} else {
				this.model.uomId = item.id;
				this.model.uom = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedUomPo(item) {
			if (item == undefined || item == null) {
				this.model.uomPoId = null;
				this.model.uomPo = null;
			} else {
				this.model.uomPoId = item.id;
				this.model.uomPo = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedVendorSubcontract: async function (item) {
			if (item == undefined || item == null) {
				this.model.vendorSubcontractId = null;
				this.model.vendorSubcontract = null;
			} else {
				this.model.vendorSubcontractId = item.id;
				this.model.vendorSubcontract = item;

				await this.checkPartClassification();
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.partInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					Part.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'partindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					Part.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'partindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					Part.updateData(this, model, id)
						.catch((error) => {
							this.getPart(id);
						});
				}
			});
		},
		onHidden() {
			this.getParts();
		},
		addRowDataPartDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.partId = this.modelId;
					PartDetail.updateDataDetail(this, model, model.id)
						.then(result => {
							this.getPartDetails(true);
							this.isShowPopupPartDetail = false;
						})
				} else {
					model.partId = this.modelId;
					PartDetail.createDataDetail(this, model)
						.then(result => {
							this.getPartDetails(true);
							this.isShowPopupPartDetail = false;
						})
				}
			}
		},
		async editRowDataPartDetail(id) {
			this.partDetailId = id;
			this.isShowPopupPartDetail = true;
		},
		async deleteRowDataPartDetail(id) {
			PartDetail.deleteData(this, id).then(result => { this.getPartDetails(); });
		},
		async resetDataPartDetail() {
			this.partDetailId = "";
			this.isShowPopupPartDetail = true;
		},
		async addDataPartDetail() {
			PartDetail.createData(this, { partId: this.modelId })
				.then(result => {
					this.getPartDetails(true);
				})
		},
		async addFromClipboardPartDetail() {
			let supplierCodes = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					supplierCodes.push({ supplierCode: item, partId: this.modelId });
				});
				PartDetail.addFromClipboard(this, supplierCodes).then(result => { this.getPartDetails() });
			});
		},
		async replaceFromClipboardPartDetail() {
			let supplierCodes = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					supplierCodes.push({ supplierCode: item, partId: this.modelId });
				});
				PartDetail.replaceFromClipboard(this, supplierCodes).then(result => { this.getPartDetails() });
			});
		},
		showPopupUploadPartDetail() {
			this.isShowPopupUploadPartDetail = true;
		},
		uploadDataPartDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPartDetail = false;
		},
		downloadPartDetail(modalEvent) {
			this.isDownloadPartDetail = true;
			this.filterPartDetail.partId = this.modelId;
			PartDetail.downloadDataDetail(this, this.filterPartDetail).then(result => {
				this.isDownloadPartDetail = false;
			}).catch(error => { this.isDownloadPartDetail = false; })
		},
		saveInputPartDetail(item) {
			if (this.vendors != null && this.vendors != undefined && this.vendors.length > 0) {
				item.supplierCode = this.vendors.find(q => q.id == item.supplierCodeId);
			}
			if (this.parts != null && this.parts != undefined && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PartDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadPartDetail = false;
			this.isShowPopupPartDetail = false;
			if (modalType == 'PartDetail') {
				this.getPartDetails();
			}
			this.showPopupCopyData = false;
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				//this.isShowPartDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterPart = new PartFilter();
		this.filterPartDetail = new PartDetailFilter();
		this.getVendorTypes()
		//this.getVendors();
		//this.getParts();
		//this.getCustomers();
		//this.getPartClassifications();
		//this.getPackagingTypes();
		//this.getUoms();
	},
	async mounted() {
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPart(id);
			} else {
				this.modelId = id;
				this.getPart(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch: {
		sortByPartDetail: {
			handler: function () {
				this.getPartDetails();
			}
		},
		sortDescPartDetail: {
			handler: function () {
				this.getPartDetails();
			}
		},
		currentPartDetailPage: {
			handler: function () {
				this.getPartDetails();
			}
		},
		partDetailPageSize: {
			handler: function () {
				this.getPartDetails();
			}
		},
		filterPartDetail: {
			handler: function () {
				this.getPartDetails();
			},
			deep: true,
		},
	},
}
</script>
